<template>
    <div class="d-flex justify-content-center py-5">
        <b-spinner variant="primary"></b-spinner>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
